import apiClient from "../apiClient";

export const getAllMemberships = async () => {
  try {
    const response = await apiClient.get("subscriptions/memberships-plans");

    return response?.data?.plans;
  } catch (error) {
    throw error;
  }
};
export const cancelSuscription = async ({ _id }) => {
  try {
    const response = await apiClient.patch(
      `membershipsUsers/cancel-membership/${_id}`
    );
    // console.log(response);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const fetchNewSessionPayment = async ({ membershipType, userId }) => {
  try {
    const response = await apiClient.post(
      `membershipsUsers/generate-payment-intent`,
      {
        membershipType: membershipType,
        userId: userId,
      }
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};
export const getPaymentHistoryMembership = async ({ userId }) => {
  try {
    const response = await apiClient.get(
      `membershipsUsers/getMembership-History/${userId}`
    );
    return response?.data?.data ?? [];
  } catch (error) {
    throw error;
  }
};
export const getMembershipByUser = async ({ userId }) => {
  try {
    const response = await apiClient.get(`membershipsUsers/getAll/${userId}`);
    // console.log("Respuesta de membresia:", response?.data?.membership);
    console.log(
      "Membresia de esquema user",
      response?.data?.membership?.fromUserSchema?.type
    );
    console.log(
      "Membresia del historial",
      response?.data?.membership?.fromMembershipHistory?.activeMemb
        ?.membershipType
    );

    if (
      response?.data?.membership?.fromMembershipHistory?.activeMemb
        ?.membershipType !== response?.data?.membership?.fromUserSchema?.type
    ) {
      return {};
    }
    return response?.data?.membership?.fromMembershipHistory ?? {};
  } catch (error) {
    throw error;
  }
};

export const getPaymentHistoryMembershipPS = async ({ userId }) => {
  try {
    const response = await apiClient.get(
      `membershipsUsers/getMembership-History-Provider/${userId}`
    );
    // console.log("Listado de pagos PS:", response?.data);

    return response?.data?.data ?? [];
  } catch (error) {
    throw error;
  }
};
export const getMembershipByUserPS = async ({ userId }) => {
  try {
    const response = await apiClient.get(
      `membershipsUsers/getAllHistory-Provider/${userId}`
    );
    // console.log("Respuesta de membresia:", response?.data?.membership);
    // console.log(
    //   "Membresia de esquema user",
    //   response?.data?.membership?.fromUserSchema?.type
    // );
    // console.log(
    //   "Membresia del historial",
    //   response?.data?.membership?.fromMembershipHistory?.activeMemb
    //     ?.membershipType
    // );

    if (
      response?.data?.membership?.fromMembershipHistory?.activeMemb
        ?.membershipType !== response?.data?.membership?.fromUserSchema?.type
    ) {
      return {};
    }
    return response?.data?.membership?.fromMembershipHistory ?? {};
  } catch (error) {
    throw error;
  }
};
